import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const ProductGallery = () => {
  const [currentImage, setCurrentImage] = useState(0);
  
  const products = [
    {
      id: 1,
      name: 'Трубы ПЭ для водоснабжения',
      diameter: '20-315 мм',
      pressure: 'PN10/PN16',
      image: "/products-slider-images/photo_1_2025-08-07_23-54-40.jpg"
    },
    {
      id: 2,
      name: 'Трубы ПЭ для канализации',
      diameter: '110-1200 мм',
      pressure: 'SN4/SN8',
      image: "/products-slider-images/photo_2_2025-08-07_23-54-40.jpg"
    },
    {
      id: 3,
      name: 'Трубы ПЭ для газоснабжения',
      diameter: '20-630 мм',
      pressure: 'SDR 11/17.6',
      image: "/products-slider-images/photo_3_2025-08-07_23-54-40.jpg"
    },
    {
      id: 4,
      name: 'Трубы многослойные',
      diameter: '110-450 мм',
      pressure: 'PN8/PN12',
      image: "/products-slider-images/photo_5_2025-08-07_23-54-40.jpg"
    },
    {
      id: 5,
      name: 'Трубы защитные',
      diameter: '50-200 мм',
      pressure: 'Техническая',
      image: "/products-slider-images/photo_6_2025-08-07_23-54-40.jpg"
    },
    {
      id: 7,
      name: 'Трубы специального назначения',
      diameter: '20-110 мм',
      pressure: 'PN6/PN10',
      image: "/products-slider-images/photo_8_2025-08-07_23-54-27.jpg"
    },
    {
      id: 6,
      name: 'Трубы промышленные',
      diameter: '63-1200 мм',
      pressure: 'SDR 21/26',
      image: "/products-slider-images/photo_16_2025-08-07_23-54-40.jpg"
    },
    {
      id: 7,
      name: 'Трубы для кабельной канализации',
      diameter: '110-200 мм',
      pressure: 'Техническая',
      image: "/products-slider-images/photo_18_2025-08-07_23-54-40.jpg"
    },
    {
      id: 8,
      name: 'Трубы напорные',
      diameter: '25-630 мм',
      pressure: 'PN16/PN20',
      image: "/products-slider-images/photo_19_2025-08-07_23-54-40.jpg"
    },
    {
      id: 9,
      name: 'Трубы дренажные',
      diameter: '110-400 мм',
      pressure: 'SN2/SN4',
      image: "/products-slider-images/photo_20_2025-08-07_23-54-40.jpg"
    },
    {
      id: 10,
      name: 'Трубы магистральные',
      diameter: '315-1200 мм',
      pressure: 'PN10/PN12.5',
      image: "/products-slider-images/photo_21_2025-08-07_23-54-40.jpg"
    },
    {
      id: 11,
      name: 'Трубы технологические',
      diameter: '20-400 мм',
      pressure: 'Различные',
      image: "/products-slider-images/photo_22_2025-08-07_23-54-40.jpg"
    }
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % products.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + products.length) % products.length);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-secondary-50 to-primary-50 dark:from-secondary-900 dark:to-secondary-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
            📸 Галерея продукции
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-secondary-900 dark:text-white mb-6">
            Наша <span className="text-primary-600">продукция</span> в деталях
          </h2>
          <p className="text-xl text-secondary-600 dark:text-secondary-300 max-w-3xl mx-auto">
            Высококачественные полиэтиленовые трубы для различных применений
          </p>
        </div>

        {/* Main Gallery */}
        <div className="relative">
          <div className="relative h-96 rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src={products[currentImage].image} 
              alt={products[currentImage].name}
              className="w-full h-full object-cover transition-all duration-500 ease-in-out"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            
            {/* Content Overlay */}
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-2xl font-bold mb-2">{products[currentImage].name}</h3>
              <div className="flex space-x-6">
                <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm">
                  Диаметр: {products[currentImage].diameter}
                </span>
                <span className="bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-sm">
                  {products[currentImage].pressure}
                </span>
              </div>
            </div>

            {/* Navigation Arrows */}
            <button 
              onClick={prevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-200"
            >
              <ChevronLeftIcon className="h-6 w-6 text-white" />
            </button>
            <button 
              onClick={nextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-200"
            >
              <ChevronRightIcon className="h-6 w-6 text-white" />
            </button>
          </div>

          {/* Thumbnails with horizontal scroll */}
          <div className="relative mt-8">
            <div className="flex justify-start overflow-x-auto scrollbar-hide space-x-4 pb-2 px-4">
              {products.map((product, index) => (
                <button
                  key={product.id}
                  onClick={() => setCurrentImage(index)}
                  className={`relative flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden transition-all duration-300 ${
                    currentImage === index 
                      ? 'ring-4 ring-primary-500 scale-110' 
                      : 'hover:scale-105 opacity-70 hover:opacity-100'
                  }`}
                >
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Product Info Cards - Show 4 items around current selection */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16">
          {(() => {
            // Calculate which 4 products to show based on current image
            const startIdx = Math.max(0, Math.min(currentImage - 1, products.length - 4));
            const endIdx = Math.min(startIdx + 4, products.length);
            const visibleProducts = products.slice(startIdx, endIdx);
            
            return visibleProducts.map((product, relativeIndex) => {
              const absoluteIndex = startIdx + relativeIndex;
              const icons = ['💧', '🏢', '🔥', '🔧', '⚙️', '🛡️', '🎯', '🏭', '📡', '💪', '🌊', '🚀', '🔬'];
              
              return (
                <div 
                  key={product.id}
                  className={`bg-white dark:bg-secondary-800 rounded-2xl p-6 shadow-custom transition-all duration-300 transform cursor-pointer ${
                    currentImage === absoluteIndex 
                      ? 'scale-105 ring-2 ring-primary-500 shadow-xl' 
                      : 'hover:scale-102 hover:shadow-lg'
                  }`}
                  onClick={() => setCurrentImage(absoluteIndex)}
                >
                  <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 rounded-xl flex items-center justify-center mb-4">
                    <span className="text-xl">
                      {icons[absoluteIndex % icons.length]}
                    </span>
                  </div>
                  <h4 className="font-bold text-secondary-900 dark:text-white mb-2">{product.name}</h4>
                  <div className="space-y-1 text-sm text-secondary-600 dark:text-secondary-300">
                    <p>Диаметр: {product.diameter}</p>
                    <p>Характеристики: {product.pressure}</p>
                  </div>
                </div>
              );
            });
          })()}
        </div>
      </div>
    </section>
  );
};

export default ProductGallery;